import { BaseService } from "./BaseService";
import { IndexService } from "./IndexService";

export class UserPreferenceService extends BaseService {
  getConfig(): any {
    return super.invokeGet(this.APICONFIG.APIBASEURL + this.APICONFIG.GETCONFIG);
  }

  getBatchConfig(): any {
    return super.invokeGet(this.APICONFIG.APIBASEURL + this.APICONFIG.GETBATCHCONFIG);
  }

  getLicences(profileId): any {
    return super.invokeGet(this.APICONFIG.APIBASEURL + this.APICONFIG.GETLICENSES + "?profileID=" + profileId);
  }

  getCustomFieldMasterData(profileId): any {
    return super.invokeGet(
      this.APICONFIG.APIBASEURL + this.APICONFIG.GETCUSTOMFIELDMASTERDATA + "?profileID=" + profileId
    );
  }

  getPmeIndexes(profileId): any {
    return new IndexService().fetchIndexes(profileId);
  }

  getMeasurement(profileId): any {
    return super.invokeGet(this.APICONFIG.APIBASEURL + this.APICONFIG.GETMEASUREMENTDATES + "?profileID=" + profileId);
  }

  getCurrency(profileId): any {
    return super.invokeGet(this.APICONFIG.APIBASEURL + this.APICONFIG.GETCURRENCIES + "?profileID=" + profileId);
  }

  getAlternateBaseCurrency(profileId): any {
    return super.invokeGet(
      this.APICONFIG.APIBASEURL + this.APICONFIG.GETALTERNATEBASECURRENCY + "?profileID=" + profileId
    );
  }
}
